module.exports = __webpack_public_path__ + "static/img/app-desc-phone.97fa2ff0.png";